import React, { useState } from "react";
import "./adduser.scss";
import axios from "axios";
import { useEffect } from "react";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";
import { useNavigate } from "react-router-dom";

function Adduser() {
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [loading, setLoading] = useState();
  const [verifyEmail, setVerifyEmail] = useState();
  const sizeImage = 1000000;

  const getRoles = async () => {
    const rest = await axios.get("https://mobile.amospa.com/roles");
    setRoles(rest.data.data);
    setAdd({ ...add, roleId: rest.data.data[0].id });
  };

  const [add, setAdd] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    roleId: null,
  });

  const [image, setImage] = useState("");

  const addStaff = async () => {
    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (
      add.name !== "" &&
      add.phone !== "" &&
      add.email !== "" &&
      add.password !== "" &&
      image !== ""
    ) {
      const data = new FormData();
      data.append("name", add.name);
      data.append("phone", add.phone);
      data.append("email", add.email);
      data.append("password", add.password);
      data.append("roleId", add.roleId);
      data.append("image", image);
      setLoading(true);
      const result = await axios.post("https://mobile.amospa.com/staff", data);
      setLoading(false);
      if (result.data?.msg === "Email sudah terdaftar") {
        setVerifyEmail(true);
      } else {
        setTitle("Success Add New Staff");
        setModalShow(true);
      }
    } else {
      setTitle("fill in all forms");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/staff/");
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-user">
                <div className="wrapper-edit-image">
                  <div className="header-edit-image">
                    <h5 className="m-0">Create New Staff</h5>
                  </div>
                  <div className="data-user">
                    <div className="wrapper-data">
                      <label>
                        Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        onChange={(e) =>
                          setAdd({ ...add, name: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="phone"
                        onChange={(e) =>
                          setAdd({ ...add, phone: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Email <span className="text-danger">*</span>
                      </label>
                      {verifyEmail && (
                        <div className="alert-email text-danger">
                          Email sudah terdaftar, gunakan Email lain. . .
                        </div>
                      )}
                      <input
                        type="text"
                        name="email"
                        onChange={(e) =>
                          setAdd({ ...add, email: e.target.value })
                        }
                      />
                    </div>

                    <div className="wrapper-data">
                      <label>
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        name="password"
                        onChange={(e) =>
                          setAdd({ ...add, password: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Role <span className="text-danger">*</span>
                      </label>
                      <select
                        name="role"
                        onChange={(e) =>
                          setAdd({ ...add, roleId: e.target.value })
                        }
                      >
                        {roles.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.role}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Image (Max 1MB)<span className="text-danger">*</span>{" "}
                        <span className="text-danger ms-2">
                          {image && image.size > sizeImage
                            ? "Image size is too Big"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="file"
                        onChange={(e) => setImage(e.target.files[0])}
                      />
                    </div>
                    <button onClick={() => addStaff()}>Create New Staff</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" &&
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Adduser;
